import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';
import '../assets/css/Post.css'
import ReactPaginate from 'react-paginate';
import { ArrowRightAlt } from '@material-ui/icons';


type PostProps = {
    // posts?: Array<any>,
    id: string,
    title: string,
    photo: string,
    desc: string,
    author: string,
    createdAt: string
}

const PostTemplate = ({id, title, photo, desc, author, createdAt}:PostProps) => {
  // console.log(new Date(createdAt).toDateString());
  const PF = "https://heroblog-api.onrender.com/images/"
  // const PF = "http://localhost:5959/images/"
  return (
    <Col>
      <Card>
      <Link to={`/post/${id}`}>{photo && <Card.Img variant="top" src={PF+photo} />}</Link>
      <Card.Body>
        <Card.Title>
        <Link to={`/post/${id}`}>{title}</Link>
        </Card.Title>
        <Card.Text>
        {desc.slice(0, 180) + '...'}
        <span className='author__date'>
        <small className="text-muted author">{author}</small>
        <small className="text-muted">{new Date(createdAt).toDateString()}</small>
        </span>
        <div className='continue'>
        <Link to={`/post/${id}`}>Continue Reading <ArrowRightAlt /></Link>
        </div>
        </Card.Text>
      </Card.Body>
    </Card>
    </Col>
  )
}

export default PostTemplate
